import { gsap, DrawSVGPlugin } from "@/utilities/gsap.js"
import { get } from "@/utilities/querySelector.js"

const curvedArrow = get('[data-curved-arrow]');

if (curvedArrow) {
    const arrowLine = get('[data-arrow-line]', curvedArrow);
    const arrowHead = get('[data-arrow-head]', curvedArrow);

    if (arrowLine && arrowHead) {
        const tl = gsap.timeline({
            defaults: { ease: "power2.out" },
            paused: true
        });

        tl.from(arrowLine, {
            duration: 1.2,
            drawSVG: 0
        })
        .from(arrowHead, {
            duration: 0.6,
            drawSVG: 0,
            opacity: 0
        }, "-=0.3");


        const checkViewState = () => {
            if (curvedArrow.getAttribute('data-in-view') === 'true') {
                tl.play();
            } else {
                tl.reverse();
            }
        };

        checkViewState();

        const observer = new MutationObserver(checkViewState);
        observer.observe(curvedArrow, {
            attributes: true,
            attributeFilter: ['data-in-view']
        });
    }
}
